module.exports = __webpack_public_path__ + "static/media/WheatStage102.cdd2b9f1.PNG";